<template>
  <div>
    <iframe ref="ifrTandC" sandbox :srcdoc="srcdoc" frameborder="0" :style="{'height' : iframeHeight}" @load="iframeLoaded"></iframe>
  </div>
</template>

<script>
  import lib from '@/library'
  import {localeProperties} from '@/library/locale/i18n'
  export default {
    name: 'termsAndConditions',
    data: () => ({
      iframeHeight: '400px',
      srcdoc: false
    }),
    methods: {
      getTermsAndConditionContent () {
        lib.rpcService.callBroker('UserService', 'GetTsAndCsText', {'IDMDLanguage': localeProperties.getUserLocale.toUpperCase(), 'versionNumber': null})
          .then(response => {
            let res = response && response.result
            let ifrTandC = this.$refs.ifrTandC
            ifrTandC = ifrTandC && (ifrTandC.contentWindow || ifrTandC.contentDocument.document || ifrTandC.contentDocument)
            if (ifrTandC) {
              this.srcdoc = res
            }
          }).catch(error => {
            console.log(error)
          })
      },
      iframeLoaded () {
        setTimeout(() => {
          let ifrTandC = this.$refs.ifrTandC
          ifrTandC = ifrTandC && (ifrTandC.contentWindow || (ifrTandC.contentDocument.document || ifrTandC.contentDocument))
          this.iframeHeight = (ifrTandC.document.body.scrollHeight + 40) + 'px'
        }, 1)
      }
    },
    mounted () {
      this.getTermsAndConditionContent()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/css/config"

  iframe
    width 100%
    height 100%
</style>



// WEBPACK FOOTER //
// src/components/termsAndConditions/termsAndConditions.vue